import React from "react";
import PropTypes from "prop-types";
import { NumberInput } from 'carbon-components-react';


function UpDownWidget(props) {

  if (!props.id) {
    console.log("No id for", props);
    throw new Error(`no id for props ${JSON.stringify(props)}`);
  }
  const {
    value,
    readonly,
    disabled,
    autofocus,
    onBlur,
    onFocus,
    options,
    schema,
    formContext,
    registry,
    rawErrors,
    ...inputProps
  } = props;

  const _onChange = ({ target: { value } }) => {
    return props.onChange(value === "" ? options.emptyValue : value);
  };
    return (
        <NumberInput
            id={inputProps.id}
            readOnly={readonly}
            disabled={disabled}
            autoFocus={autofocus}
            value={value == null ? "" : value}
            labelText=""
            {...inputProps}
            onBlur={onBlur && (event => onBlur(inputProps.id, event.target.value))}
            onFocus={onFocus && (event => onFocus(inputProps.id, event.target.value))}
            onChange={_onChange}
            invalid={rawErrors && rawErrors.length > 0 ? true : false}
        />
    );
}

if (process.env.NODE_ENV !== "production") {
  UpDownWidget.propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  };
}

export default UpDownWidget;
